import {
  FaHardHat,
  FaClock,
  FaHandshake,
  FaShieldAlt,
  FaUsers,
  FaAward,
} from "react-icons/fa";
import { motion } from "framer-motion";

const HeroWhyChoose = () => {
  const features = [
    {
      icon: <FaHardHat />,
      title: "Expert Construction Team",
      description:
        "Experienced engineers, architects and project managers delivering excellence in every project.",
    },
    {
      icon: <FaClock />,
      title: "On-Time Project Delivery",
      description:
        "We follow strict timelines and efficient planning to complete projects on schedule.",
    },
    {
      icon: <FaHandshake />,
      title: "Transparent Process",
      description:
        "Complete transparency in pricing, project updates and communication throughout the project.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Quality Assurance",
      description:
        "We use quality materials and industry best practices to ensure long-lasting results.",
    },
    {
      icon: <FaUsers />,
      title: "Customer-Centric Approach",
      description:
        "Client satisfaction is at the core of every decision and service we provide.",
    },
    {
      icon: <FaAward />,
      title: "Trusted & Reliable",
      description:
        "A reputation built on trust, professionalism and successful project execution.",
    },
  ];

  return (
    <section className="py-12 md:py-24 bg-white overflow-hidden">
      <div className="container-custom">
        
        {/* Heading */}

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] font-semibold uppercase tracking-widest">
            Why Choose Us
          </span>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            Why Clients Trust
            <span className="text-[#F59E0B]"> AZ Construction</span>
          </h2>

          <p className="text-gray-600 mt-6 leading-8">
            We combine industry expertise, innovative solutions and
            customer-focused service to deliver projects that exceed
            expectations.
          </p>

        </div>

        {/* Cards */}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

          {features.map((item, index) => (
            <motion.div
              key={index}
              initial={{
                opacity: 0,
                y: 50,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.5,
                delay: index * 0.1,
              }}
              viewport={{ once: true }}
              className="group bg-white border border-gray-100 rounded-3xl p-6 sm:p-8 shadow-sm hover:shadow-2xl hover:-translate-y-3 transition-all duration-500"
            >
              <div className="w-20 h-20 rounded-2xl bg-[#082B57]/10 flex items-center justify-center text-3xl text-[#082B57] group-hover:bg-[#F59E0B] group-hover:text-white transition-all duration-500">
                {item.icon}
              </div>

              <h3 className="text-2xl font-bold text-[#082B57] mt-6">
                {item.title}
              </h3>

              <p className="text-gray-600 mt-4 leading-7">
                {item.description}
              </p>
            </motion.div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default HeroWhyChoose;